import { RootState } from '../reducers';

export function getDeviceAuthCode({ deviceAuth }: RootState) {
  return deviceAuth.code;
}

export function getDeviceAuthValidationError({ deviceAuth }: RootState) {
  return deviceAuth.validationError;
}

export function getIsValidatingDeviceAuthCode({ deviceAuth }: RootState) {
  return deviceAuth.isValidatingCode;
}

export function getDeviceAuthCodeStatus({ deviceAuth }: RootState) {
  return deviceAuth.status;
}

export function getIsActivatingDevice({ deviceAuth }: RootState) {
  return deviceAuth.isActivatingDevice;
}

export function getDeviceAuthRedirectURL({ deviceAuth }: RootState) {
  return deviceAuth.redirectURL;
}
